<app-page>
  <creators-leaderboard></creators-leaderboard>
</app-page>
